import http from "../http";

const common={
    /**
     * 获取地区树
     * @returns
     */
    getAreaTree(){
        return http.get("/work_order/common/area/tree");
    },
    /**
     * 获取项目树
     * @returns
     */
    getProjectTree(){
        return http.get("/work_order/common/project/tree");
    },
    /**
     * 获取机构列表
     * @returns
     */
    getCompanyList(params){
        return http.get("/work_order/common/company/page",{params});
    },

}
export default common;
